import { createFileRoute } from '@tanstack/react-router'
import { Suspense, lazy } from 'react'
import { protectedRouteGuard } from '@/utils/routeGuards'

import { Loading } from '@/components/Loading'

const AddSubnetPage = lazy(() => import('@/pages/infra/AddSubnetPage'))

export const Route = createFileRoute('/infra/network/add-subnet')({
  loader: () => ({
    crumb: 'Add Subnet',
  }),
  beforeLoad: protectedRouteGuard,
  component: () => (
    <Suspense fallback={<Loading />}>
      <AddSubnetPage />
    </Suspense>
  ),
})
